<template>
  <div :class="$style.overviewSection">

    <div :class="getOverviewContainerStyle">

      <div :class="$style.overviewInner">
        <slot name="overviewImage" />

        <h1 :class="$style.overviewTitle">
          <span>{{ title }}</span>
        </h1>

        <slot name="overviewContent"/>
      </div>

    </div>

    <div>
      <slot name="overviewControls" />
    </div>

  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    qualify: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getOverviewContainerStyle() {
      if (this.qualify) {
        return [this.$style.overviewContainer, this.$style.overviewContainerWide];
      }

      return this.$style.overviewContainer;
    },
  },
};
</script>

<style lang="scss" module>
@import "~@/styles/variables.scss";

.overviewSection {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('@/assets/img/Cover_bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  .overviewContainer {
    min-width: 600px;
    max-width: 80%;
    min-height: 532px;
    display: flex;
    flex-direction: column;
    background: $overview-gradient;
    padding: 8px;
    box-shadow: $images-shadow;

    &.overviewContainerWide {
      max-width: 100%;
      width: 100%;
      margin: 0 40px;
    }

    .overviewInner {
      flex-grow: 1;
      border: $image-border;
      padding: 40px;
      text-align: center;
    }
  }
}

.overviewTitle {

  span {
    position: relative;
    padding: 0 27px;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      height: 4px;
      background-color: $wizard-title-color;
      width: 125px;
    }

    &::before {
      left: -125px;
    }

    &::after {
      right: -125px;
    }
  }
}

</style>
